import React from 'react';
import StatusBadge from '../../../components/ui/StatusBadge';
import {
  KB_STATUS_SHORT_LABELS,
  getStatusIcon,
  statusShouldSpin,
} from '../../../support/iconMappings';
import { KB_STATUS_LABELS, KB_STATUS_STYLES } from '../constants';

function KnowledgeStatusBadge({ status, compact = false }) {
  const fullLabel = KB_STATUS_LABELS[status] || status;
  const shortLabel = KB_STATUS_SHORT_LABELS[status] || fullLabel;
  const style = KB_STATUS_STYLES[status] || 'bg-slate-100 text-slate-600 border-slate-200';
  const Icon = getStatusIcon('kb', status);

  return (
    <StatusBadge
      label={shortLabel}
      title={fullLabel}
      styleClass={style}
      icon={Icon}
      compact={compact}
      spin={statusShouldSpin('kb', status)}
    />
  );
}

export default KnowledgeStatusBadge;
